module.exports = __webpack_public_path__ + "img/mailbox2.da8e3f2c.svg";